<div class="user_detail_section h-full w-full">
  <div class="detail_row">
    <label>First Name</label>
    <span>{{ profileDetails?.firstName || '' }}</span>
  </div>
  <div class="detail_row">
    <label>Last Name</label>
    <span>{{ profileDetails?.lastName || '' }}</span>
  </div>
  <div class="detail_row">
    <label>Email</label>
    <span>{{ profileDetails?.email || '' }}</span>
  </div>
  <div class="detail_row">
    <label>Contact No</label>
    <span>{{ profileDetails?.contactNo || '' }}</span>
  </div>
  <div class="detail_row">
    <label>Role</label>
    <span>{{ profileDetails?.roleName || '' }}</span>
  </div>
  <div class="detail_row">
    <label>Last Logged In</label>
    <span>{{ profileDetails?.lastLoggedInDisplay || '' }}</span>
  </div>
  <div class="detail_row">
    <label>Status</label>
    <p-tag [severity]="profileDetails?.isActive ? 'success' : 'danger'"
      [value]="profileDetails?.isActive ? 'Active' :'Inactive'" />
  </div>
</div>
